import { atom } from 'recoil';

export const warehouseState = atom({
  key: 'warehouse_list',
  default: {
    items: [{ address: { street: null, street2: null } }],
    desc: null,
    order_by: null,
    total: null,
    size: null,
    screen: undefined,
  },
});

export const turnOnCloneUserState = atom({
  key: 'turn_on_clone_user',
  default: false,
});

export const warehouseDetailUsersState = atom({
  key: 'warehouse_detail_user',
  default: {
    desc: true,
    order_by: 'id',
    size: 1000,
  },
});
